module.exports = __webpack_public_path__ + "static/media/device.f3122145.svg";